<template>
  <div class="data-statistics">
    <UserOverviewStatistics />
    <UserGrowthTrend />
    <BusinessHandlingStatistics />
    <BusinessHandlingGrowthTrend />
    <WorkTypeDistribution />
    <BusinessHandlingRanking />
  </div>
</template>

<script>
import UserOverviewStatistics from './UserOverviewStatistics.vue'
import UserGrowthTrend from './UserGrowthTrend.vue'
import BusinessHandlingStatistics from './BusinessHandlingStatistics.vue'
import BusinessHandlingGrowthTrend from './BusinessHandlingGrowthTrend.vue'
import WorkTypeDistribution from './WorkTypeDistribution.vue'
import BusinessHandlingRanking from './BusinessHandlingRanking.vue'

export default {
  name: 'NormalChannelDataStatistics',
  components: {
    UserOverviewStatistics,
    UserGrowthTrend,
    BusinessHandlingStatistics,
    BusinessHandlingGrowthTrend,
    WorkTypeDistribution,
    BusinessHandlingRanking
  }
}
</script>

<style lang="scss" scoped>
.data-statistics {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 4px 0;
  flex-direction: column;
  gap: 16px;
}

@media (max-width: 768px) {
  .data-statistics {
    gap: 14px;
  }
}
</style>
